export default __webpack_public_path__ + "pgnv-assets/6ac78c4b989ec37aba7f1efb7a2e120c.png";